import React from "react";

import withRouter from '../helpers/withRouter';
import { metricDataSource } from "../helpers/gridHandler";

import { Alert, Card } from "react-bootstrap";
import DataGridGeneric from "./DataGridGeneric";
import moment from "moment";

class PerformanceAppPlanMetrics extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
          data: [],  
          loading: true, 
          refreshDate: null
      };
    }

    componentDidMount() {
      this.fetchMetrics();
      this.fetchRefreshDate();
    }

    componentDidUpdate(prevProps) {
      if (prevProps.refreshTrigger !== this.props.refreshTrigger) {
        this.fetchRefreshDate();
        this.fetchMetrics();
      }
    }

    fetchRefreshDate = async () => {
        try {
            this.setState({ loading: true });
            const response = await metricDataSource(global.config.backend.baseURI + "/api/Metric/GetLastRefresh");
            const jsonData = response;
            console.log(jsonData.LastRefreshDate);


            this.setState({ refreshDate: moment(jsonData.LastRefreshDate).format('YYYY-MM-DD HH:mm:ss'), loading: false });

        } catch (error) {
            console.error("Error fetching performance metrics:", error);
            this.setState({ loading: false });
        }
    };

    fetchMetrics = async () => {
        try {
            this.setState({ loading: true });
            const response = await metricDataSource(global.config.backend.baseURI + "/api/Metric/GetDatabasePerformanceMetric");
            const jsonData = response;

            // Transform the API response into an array
            const transformedData = Object.keys(jsonData)
            .map((resourceName, index) => {
                const resourceMetrics = jsonData[resourceName];
      
                const isCritical = Object.values(resourceMetrics).some(
                    (timeData) => (timeData?.cpu_percent || 0) > 80 || (timeData?.storage_percent || 0) > 80
                );
      
                const timePeriods = ["Current", "1 Hour", "6 Hours", "12 Hours", "1 Day"];
                
                let transformedMetrics = {
                    id: index + 1,
                    resourceName,
                    critical: isCritical,
                };
      
                timePeriods.forEach((period) => {
                    transformedMetrics[`${period}_cpu`] = Math.round((resourceMetrics[period]?.["cpu_percent"] || 0) * 100) / 100;
                    transformedMetrics[`${period}_storage`] = Math.round((resourceMetrics[period]?.["storage_percent"] || 0) * 100) / 100;
                });
      
                return transformedMetrics;
            })
            .sort((a, b) => b.critical - a.critical);

            this.setState({ data: transformedData, loading: false });

        } catch (error) {
            console.error("Error fetching performance metrics:", error);
            this.setState({ loading: false });
        }
    };

    columns = [
      {
          dataField: "resourceName",
          caption: "Resource Name",
          width: 200,
          fixed: true,
          cellTemplate: 'importanceMetric',
      },
      {
          caption: "Current",
          alignment: "center",
          columns: [
              { dataField: "Current_cpu", caption: "CPU (%)", alignment: "center", cellTemplate: 'performanceMetric' },
              { dataField: "Current_storage", caption: "Storage (%)", alignment: "center", cellTemplate: 'performanceMetric' },
          ],
      },
      {
          caption: "1 Hour",
          alignment: "center",
          columns: [
              { dataField: "1 Hour_cpu", caption: "CPU (%)", alignment: "center", cellTemplate: 'performanceMetric' },
              { dataField: "1 Hour_storage", caption: "Storage (%)", alignment: "center", cellTemplate: 'performanceMetric' },
          ],
      },
      {
          caption: "6 Hours",
          alignment: "center",
          columns: [
              { dataField: "6 Hours_cpu", caption: "CPU (%)", alignment: "center", cellTemplate: 'performanceMetric' },
              { dataField: "6 Hours_storage", caption: "Storage (%)", alignment: "center", cellTemplate: 'performanceMetric' },
          ],
      },
      {
          caption: "12 Hours",
          alignment: "center",
          columns: [
              { dataField: "12 Hours_cpu", caption: "CPU (%)", alignment: "center", cellTemplate: 'performanceMetric' },
              { dataField: "12 Hours_storage", caption: "Storage (%)", alignment: "center", cellTemplate: 'performanceMetric' },
          ],
      },
      {
          caption: "1 Day",
          alignment: "center",
          columns: [
              { dataField: "1 Day_cpu", caption: "CPU (%)", alignment: "center", cellTemplate: 'performanceMetric' },
              { dataField: "1 Day_storage", caption: "Storage (%)", alignment: "center", cellTemplate: 'performanceMetric' },
          ],
      }
    ];

    render() { 
        return (
          <Card className="rounded-4">
            <Card.Body>
              <Card.Title>
                  Azure Database Resources Performance (Refreshed: {this.state.refreshDate})
              </Card.Title>
              <Card.Subtitle>
                Performance Metrics for Database Resources with Azure for FastDraft Services
              </Card.Subtitle>
              {this.state.loading ? (
                <Alert variant="info" style={{marginTop: '45px'}}>
                    <h4>Loading metrics (this will take a while and is cached for 5 minuntes)</h4>
                </Alert>
              ) : (
                  <DataGridGeneric
                      id="gridGenericContainer"
                      dataSource={this.state.data}
                      columns={this.columns}
                  />
              )}
            </Card.Body>
          </Card>
        );
    }
}

export default withRouter(PerformanceAppPlanMetrics);